module.exports = __webpack_public_path__ + "static/media/banner.5a035507.jpg";